export default (allEntityAdmins, contactList) =>
	contactList.filter(({userId}) => allEntityAdmins.some((admin) => userId === admin.userId));
